var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "更换用户名",
        width: "540px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "changeRobot overflowOuto",
        },
        [
          _c("div", { staticClass: "changeRobotTips" }, [
            _c("i", { staticClass: "el-icon-warning-outline" }),
            _vm._v(" 选择更换用户名，将更新本脚本下的该用户的所有发言内容。 "),
          ]),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": "auto",
                size: "small",
                rules: _vm.rules,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "原用户名", prop: "originalRobotId" } },
                [
                  _c("AppSelect", {
                    attrs: {
                      value: _vm.form.originalRobotId,
                      label: _vm.form.originalRobotName,
                      "get-api-fn": _vm.getOriginalRobot,
                      "search-key": "robotNickName",
                      "popover-width": 423,
                      props: {
                        label: "robotNickName",
                        value: "robotId",
                      },
                    },
                    on: { selected: _vm.selectOriginalRobot },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return _c(
                            "div",
                            { staticClass: "robotSelectLabel" },
                            [
                              _c("AppAvatar", {
                                attrs: {
                                  avatar: row.robotHeadPic,
                                  name: row.robotNickName,
                                  width: 26,
                                  "no-name": true,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "myLabel",
                                  attrs: { title: row["robotNickName"] },
                                },
                                [_vm._v(_vm._s(row["robotNickName"]))]
                              ),
                            ],
                            1
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "新用户名", prop: "newRobotId" } },
                [
                  _c("AppSelect", {
                    attrs: {
                      value: _vm.form.newRobotId,
                      label: _vm.form.newRobotName,
                      "get-api-fn": _vm.getAllRobot,
                      "search-key": "robotNickName",
                      "popover-width": 423,
                      props: {
                        label: "robotNickName",
                        value: "robotId",
                      },
                    },
                    on: { selected: _vm.selectRobot },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return _c(
                            "div",
                            { staticClass: "robotSelectLabel" },
                            [
                              _c("AppAvatar", {
                                attrs: {
                                  avatar: row.robotHeadPic,
                                  name: row.robotNickName,
                                  width: 26,
                                  "no-name": true,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "myLabel",
                                  attrs: { title: row["robotNickName"] },
                                },
                                [_vm._v(_vm._s(row["robotNickName"]))]
                              ),
                            ],
                            1
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }